import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/search/page.tsx");
